import React from 'react';
import { useHistory } from 'react-router';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import notFoundCone from '../../assets/images/not-found-cone.svg';
import Layout from '../../layout/Layout';
import { Button } from '../../components/Common/Components';
import { useAuth } from '../../hooks/useAuth';
import { ROUTES } from '../../constants/route';
import { UserRoles } from '../../constants/role';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    maxWidth: '412px',
  },
  imgCone: {
    height: '222px',
    width: '378px',
    marginTop: '80px',
    marginBottom: '80px',

    [theme.breakpoints.down('sm')]: {
      height: '136px',
      width: '232px',
      marginTop: '40px',
      marginBottom: '40px',
    },
  },
}));

type NotFoundPageComponent = React.FC

const NotFoundPage: NotFoundPageComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const { role, isAuthenticated } = useAuth();

  const onRefresh = () => {
    if (isAuthenticated) {
      history.push(ROUTES.MERCHANT);
    } else {
      history.push('/');
    }
  };

  return (
    <Layout>
      <div className={classes.root}>
        <div className={classes.content}>
          <Typography variant="h1" color="primary">
            Oops, it looks like something went wrong!
          </Typography>

          <img src={notFoundCone} className={classes.imgCone} alt="Not Found Cone" />

          <Button className="wide" onClick={onRefresh}>
            Refresh
          </Button>
        </div>
      </div>
    </Layout>
  );
}

export default NotFoundPage;
